import api from "../../core/api";
import { Page } from "../../shared/models/models";
import { AdminChangeStockItemModel, AdminStockItem, AdminStockItemsQuery } from "../models/AdminStockItemsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class AdminStockItemsApi {
  getStockItems(query: AdminStockItemsQuery): Promise<Page<AdminStockItem>> {
    return api.get<Page<AdminStockItem>>(`/v1/admin/stock-items`, { ...getRequestConfig(), params: query }).then(x => x.data);
  }

  getStockItem(id: string): Promise<AdminStockItem> {
    return api.get<AdminStockItem>(`/v1/admin/stock-items/${id}`, getRequestConfig()).then(x => x.data);
  }

  changeStockItem(id: string, model: AdminChangeStockItemModel): Promise<any> {
    return api.put<any>(`/v1/admin/stock-items/${id}`, model, getRequestConfig()).then(x => x.data);
  }
}

export default new AdminStockItemsApi();